import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=764faea5&scoped=true"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"
import style0 from "./auth.vue?vue&type=style&index=0&id=764faea5&prod&lang=scss&scoped=true"
import style1 from "./auth.vue?vue&type=style&index=1&id=764faea5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764faea5",
  null
  
)

export default component.exports